export const getCurrentMonth = (monthDiff: number, currentDate: Date) =>
  new Date(currentDate.getFullYear(), currentDate.getMonth() - monthDiff + 1).getMonth();
